import styled from "styled-components";
import ReactModal from "react-modal";
import { colorWhite } from "@nib-components/theme";
import { breakpoint } from "@nib/layout";
import { mixins, variables } from "@nib-group/chatbot-shared/styles";
export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;

  button {
    margin: 5px 0;
  }

  ${breakpoint("md")`
		flex-direction: row;

		button {
			margin: 0 5px;
		}
	`}
`;
export const Modal = styled(ReactModal)`
  ${mixins.alignCentre}
  box-shadow: ${variables.BOX_SHADOW};
  border-radius: 4px;
  background: ${colorWhite};
  width: 300px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 20px;

  ${breakpoint("md")`
		height: 150px;
		width: 350px;
	`}
`;